<script>
import { Pie } from 'vue-chartjs';
import 'chartjs-plugin-colorschemes/src/plugins/plugin.colorschemes';
import { Accent8, Paired12, SetThree12 } from 'chartjs-plugin-colorschemes/src/colorschemes/colorschemes.brewer';

export default {
  extends: Pie,
  props: ['chartdata', 'color'],
  data : function() {
    return {
      colors : [Accent8, Paired12, SetThree12],
      options : {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          outlabels : false
        }
      },
    }
  },
  mounted () {
    if (!this.color) {
      this.color = 0;
    }
    const chartData = {
      datasets: [{
        borderWidth : 0,
        backgroundColor : this.colors[this.color],
        data: Object.entries(this.chartdata).map(item => { return item[1].total })
      }],
      labels : Object.entries(this.chartdata).map(item => { return item[1].name + ": " + item[1].total})
    };
    this.renderChart(chartData, this.options);
  }
}
</script>

<style>
</style>